import React, {Component} from "react";
import {Alert, Snackbar} from "@mui/material";

var self = null;
export default class ToastManager extends Component {

    componentWillMount() {
        this.setState({
            message: '',
            open:false,
            display: "none",
            severity:'info'
        });
        self = this;
    }
    static showToast(msg, title) {
        let dealyTime = 3000;
        let hideProgres = true;
        if (title == "Error") {
            self.setState({message:msg,severity:"error",open:true});
        } else if (title == "Success") {
            self.setState({message:msg,severity:"success",open:true});
        } else if (title == "Info") {

        } else if (title == "Warn") {

        }
    }

    handleClose(){
        self.setState({open:false});
    }

    render() {
        return (
            <div>
                <Snackbar anchorOrigin={{horizontal: "right", vertical: "top"}} open={this.state.open} onClose={this.handleClose}
                          autoHideDuration={3000}>
                    <Alert severity={this.state.severity} onClose={this.handleClose} sx={{ width: '100%' }}>
                        {this.state.message}
                    </Alert>
                </Snackbar>
            </div>
        )
    }
}
